module.exports = __webpack_public_path__ + "img/School uniform.94f951c2.jpg";